export default "__VITE_ASSET__Bc9AQ5a0__ 1200w";